import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { getDimensionTree } from '../components/utils'
import { dimensionTreeWithRootSelector } from '../selectors/selectors'
import { getDimensionOptions } from './getDimensionOptions'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { Dimension } from '../types/Dimension'

export const useCompanyDimensionTreeWithRoot = (companyId?: string) => {
  const contextCompanyId = useSelector(contextCompanyIdSelector)
  const effectiveCompanyId = companyId || contextCompanyId

  const options = getDimensionOptions(effectiveCompanyId, (dimensions: Dimension[]) => {
    const tree = getDimensionTree(dimensions)
    return dimensionTreeWithRootSelector(effectiveCompanyId || '', tree)
  })

  return useQuery(options)
}
